import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import { ActeARealiseDetailsTableListeComponent } from './acte-a-realise-details-table.liste.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  exports: [ActeARealiseDetailsTableListeComponent],
  declarations: [ActeARealiseDetailsTableListeComponent],
  providers: [],
})
export class ActeARealiseDetailsTableListeModule {
}
